import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { getOwnersByIds, searchOwners } from '../../services/owners';
import { debounce } from '../../utils/helper';
import { onQuerySuccess } from '../../utils/queryResponse';
import FormSelect from '../forms/formSelect';

const OwnerSelect = ({ value, onChange, isMulti, setOwnerId, ...rest }) => {

    const [searchParams] = useSearchParams();
    const ownersIds = searchParams.get('ownerId')

    const [options, setOptions] = useState([])
    const [inputText, setInputText] = useState('')

    const [isLoading, setIsLoading] = useState(false)
    const isSelecting = useRef()
    const isUnmounted = useRef()

    useEffect(() => {
        isUnmounted.current = false
        ownersIds && fetchOwnersByIds(ownersIds)
        return () => {
            isUnmounted.current = true
        }
    }, [])

    useEffect(() => {
        isSelecting.current = false
    }, [])

    useEffect(() => {
        fetchSearch(inputText)
    }, [inputText])

    const fetchOwnersByIds = async (ownersIds) => {
        const data = await getOwnersByIds(ownersIds)
        onQuerySuccess(data, (result) => {

            console.log(result)
            setOptions(result.map(x => {
                return {
                    value: x.id,
                    label: `${x.name}, #${x.number}`
                }
            }))
            setOwnerId(result.map(x => x.id))
        })
    }

    const fetchSearch = useMemo(
        () =>
            debounce(async (text) => {

                if (text === "") {
                    //TODO: isSelecting.current && setOptions([])
                    return
                }

                setIsLoading(true)
                const { result, statusCode } = await searchOwners(text)
                if (isUnmounted.current) return;

                if (statusCode === 200) {
                    setOptions(result.map(d => ({
                        value: d.id, label: d.owner
                    })))
                }
                setIsLoading(false)
            }),
        []
    )

    const handleInputChange = (text) => {
        setInputText(text)
    }

    const handleOnCloseMenu = () => {
        if (isSelecting.current) {
            setInputText('')
            isSelecting.current = false
        } else {
            setInputText(inputText)
        }
    }

    const handleSearchSelect = (option) => {
        const ownerIds = []
        option.forEach(x => {
            ownerIds.push(x.value)
        });
        setOwnerId(ownerIds)
        setInputText(option?.label)
        isSelecting.current = true
    }

    return (
        <FormSelect isMulti={isMulti} {...rest}
            value={
                // match value to options value
                isMulti ? value && options.filter(opt => value.includes(opt.value)) :
                    options.find(opt => opt.value === value) || null
            }
            inputValue={inputText}
            options={options}
            // return only value of selected option/options
            onChange={handleSearchSelect}
            onInputChange={handleInputChange}
            onMenuClose={handleOnCloseMenu}
            isLoading={isLoading}
            blurInputOnSelect
            isSeachable
            isClearable
        />
    )
}

export default OwnerSelect